import React from "react"

import { 
    Authenticator as AmplifyAuthenticator,
} from "@aws-amplify/ui-react"

import { 
    BrowserRouter, 
} from "react-router-dom"

import EMETLRoutes from "./EMETLRoutes"

const EMETLAuthenticator = ({ children = undefined }) => {    
    return (
        <AmplifyAuthenticator 
        >
            {_awsRes => (
                <BrowserRouter>
                    <EMETLRoutes />
                    {children}
                </BrowserRouter>
            )}
        </AmplifyAuthenticator>
    )
}

export default EMETLAuthenticator